import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Home from "./components/home";
import Schedule from "./components/schedule";
import Members from "./components/members";
import Navigation from "./components/navigation";
import Races from "./components/races";
import Weather from "./components/weather";
import OtherLinks from "./components/otherlinks";
import Admin from "./components/admin";
import Directory from "./components/directory";
import Sponsors from "./components/sponsors";
import Footer from "./components/atoms/molecules/Footer";
import FuturityResults from "./components/futurityresults";
import CJCResults from "./components/cjcresults";
import Notificationoptin from "./components/notificationoptin";
import NotificationForm from "./components/notificationform";
import IFConvention2026 from "./components/IFConvention2026";
import { RaceParticipantsPage, ParticipantLoginPage, ParticipantDashboard } from './features/race';
import ParticipantSignupPage from './features/race/pages/ParticipantSignupPage';
import RaceLandingPage from './features/race/pages/RaceLandingPage';
import RaceLoginPage from './features/race/pages/RaceLoginPage';
import PinEntryPage from './features/race/pages/PinEntryPage';
import { ParticipantStoreProvider } from './features/race/store/participantStore';
import ModernDashboard from './features/race/pages/ModernDashboard';

//import "bootstrap/dist/css/bootstrap.css";
//import "bootstrap/dist/js/bootstrap.js";
import RacesEdit from "./components/races-edit";
import StoreProvider from "./store";
import NoMatch from "./components/atoms/NoMatch";
import 'bootstrap/dist/css/bootstrap.min.css';
//import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <HelmetProvider>
      <Helmet>
      <meta property="og:title" content="Central Jersey Homing Pigeon Combine - CJC." />
      <meta property="og:description" content="The Central Jersey Combine is an organization composed of local racing pigeon clubs in New Jersey and Staten Island, NY.
      We are dedicated for promoting good sportmanship among our members and well being of racing pigeons."/>
      <meta property="og:image" content="http://www.cjccombine.com/static/media/cjclogosmall.c1e3060e.png" />
      <meta property="og:url" content="www.cjccombine.com" />
      <meta property="og:type" content="website" />
    </Helmet>
    <StoreProvider>
      <div className="main">
        <Router>
          <div className="nav-wrapper">
            <Navigation></Navigation>
          </div>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/home" exact component={Home} />
            <Route path="/schedule" exact component={Schedule} />
            <Route path="/races" exact component={Races} />
            <Route path="/cjcresults" exact component={CJCResults} />
            <Route path="/futurityresults" exact component={FuturityResults} />
            <Route path="/members" component={Members} />
            <Route path="/directory" component={Directory} />
            <Route path="/weather" component={Weather} />
            <Route path="/otherlinks" component={OtherLinks} />
            <Route path="/admin" component={Admin} />
            <Route path="/sponsors" component={Sponsors} />
            <Route path="/notificationoptin" component={Notificationoptin} />
            <Route path="/notificationform" component={NotificationForm} />
            <Route path="/if-convention-2026" exact render={() => <Redirect to="/race" />} />
            <ParticipantStoreProvider>
              <Route path="/race" exact component={RaceLandingPage} />
              <Route path="/race/details" exact component={IFConvention2026} />
              <Route path="/race/participants" exact component={RaceParticipantsPage} />
              <Route path="/race/signup" exact component={ParticipantSignupPage} />
              <Route path="/race/select-login" exact component={RaceLoginPage} />
              <Route path="/race/pin-entry" exact component={PinEntryPage} />
              <Route path="/race/login" component={ParticipantLoginPage} />
              <Route path="/race/dashboard" component={ModernDashboard} />
            </ParticipantStoreProvider>
            <Route component={NoMatch} />
          </Switch>
          <Footer></Footer>
        </Router>
      </div>
    </StoreProvider>
    </HelmetProvider>
  );
}

export default App;

